import * as actions from "../action.constants";

const requestListofAlerts = (pageUrl) => ({
  type: actions.REQUEST_ALERTS_SAGA,
  pageUrl,
});

const requestListofSensorAlerts = (pageUrl) => ({
  type: actions.REQUEST_SENSOR_ALERTS_SAGA,
  pageUrl,
});

const requestDowntimeCreateData = () => ({
  type: actions.REQUEST_DOWNTIME_CREATE_DATA,
});

const storeDowntimeCreateData = (data) => ({
  type: actions.STORE_DOWNTIME_CREATE_DATA,
  payload: data,
});

const requestMetricCreateData = () => ({
  type: actions.REQUEST_METRIC_CREATE_DATA,
});

const storeMetricCreateData = (data) => ({
  type: actions.STORE_METRIC_CREATE_DATA,
  payload: data,
});

const requestMetricField = (data) => ({
  type: actions.REQUEST_METRIC_FIELD,
  payload: data,
});

const storeMetricField = (data) => ({
  type: actions.STORE_METRIC_FIELD,
  payload: data,
});

const storeSensorsForAlert = (data) => ({
  type: actions.STORE_SENSORS_FOR_ALERT,
  payload: data,
});

const createDowntimeAlert = (requestPayload, id, callback) => ({
  type: actions.CREATE_DOWNTIME_ALERT,
  requestPayload,
  id,
  callback,
});

const createSensorDowntimeAlert = (requestPayload, id, callback) => ({
  type: actions.CREATE_SENSOR_DOWNTIME_ALERT,
  requestPayload,
  id,
  callback,
});

const createMetricAlert = (requestPayload, id, callback) => ({
  type: actions.CREATE_METRIC_ALERT,
  requestPayload,
  id,
  callback,
});

const deleteAlertData = (id, callback) => ({
  type: actions.DELETE_ALERT_DATA,
  payload: id,
  callback,
});

const deleteSensorAlertData = (id, callback) => ({
  type: actions.DELETE_SENSOR_ALERT_DATA,
  payload: id,
  callback,
});

const toggleAlertState = (data, callback) => ({
  type: actions.TOGGLE_ALARM_STATE,
  payload: data,
  callback,
});

const toggleSensorAlertState = (data, callback) => ({
  type: actions.TOGGLE_SENSOR_ALARM_STATE,
  payload: data,
  callback,
});

const requestDowntimeGraph = (data) => ({
  type: actions.REQUEST_DOWNTIME_GRAPH,
  payload: data,
});

const requestSensorDowntimeGraph = (data) => ({
  type: actions.REQUEST_SENSOR_DOWNTIME_GRAPH,
  payload: data,
});

const requestSensorList = (data) => ({
  type: actions.REQUEST_SENSOR_LIST,
  payload: data,
});

const requestMetricGraph = (data) => ({
  type: actions.REQUEST_METRIC_GRAPH,
  payload: data,
});

const requestAlarmHistory = (id) => ({
  type: actions.REQUEST_ALARM_HISTORY,
  payload: id,
});

const requestAlarmHistoryLogs = (id) => ({
  type: actions.REQUEST_ALARM_HISTORY_LOGS,
  payload: id,
});

const requestSensorAlertAlarmHistory = (id) => ({
  type: actions.REQUEST_SENSOR_ALERT_HISTORY,
  payload: id,
});

const requestSensorAlertAlarmHistoryLogs = (id) => ({
  type: actions.REQUEST_SENSOR_ALERT_HISTORY_LOGS,
  payload: id,
});

const storeAlarmHistoryLogs = (data) => ({
  type: actions.STORE_ALARM_HISTORY_LOGS,
  payload: data,
});

const handoffAlert = (payload, callback) => ({
  type: actions.ALERT_HANDOFF,
  payload,
  callback,
});

const handoffSensorAlert = (payload, callback) => ({
  type: actions.SENSOR_ALERT_HANDOFF,
  payload,
  callback,
});

export {
  requestListofAlerts,
  requestListofSensorAlerts,
  requestDowntimeCreateData,
  storeDowntimeCreateData,
  requestMetricCreateData,
  storeMetricCreateData,
  requestMetricField,
  storeMetricField,
  storeSensorsForAlert,
  createDowntimeAlert,
  createSensorDowntimeAlert,
  createMetricAlert,
  deleteAlertData,
  deleteSensorAlertData,
  toggleAlertState,
  toggleSensorAlertState,
  requestDowntimeGraph,
  requestSensorDowntimeGraph,
  requestSensorList,
  requestMetricGraph,
  requestAlarmHistory,
  requestSensorAlertAlarmHistory,
  requestAlarmHistoryLogs,
  requestSensorAlertAlarmHistoryLogs,
  storeAlarmHistoryLogs,
  handoffAlert,
  handoffSensorAlert,
};
